import React, { useState } from 'react';
import {Box, Flex, Button, Link, Text} from '@chakra-ui/react';

import {ABOUT, HOMEPAGE, ABOUTDSA, DOWNLOAD} from '../../Navigation/paths';
import {HeadBar} from '../../molecules/HeadBar/HeadBar';
import {Footer} from '../../molecules/Footer/Footer';
import {Paragraph} from '../../helpers/Paragraph';
import getText from '../../helpers/dictionary/getText';

export const FindOutMore = (props) => {

  const links = [
    {
      href: ABOUT,
      text: "whatIs"
    },
    {
      href: HOMEPAGE + "#about_us",
      text: "team"
    },
    {
      href: HOMEPAGE + "#contact_us",
      text: "contact"
    }
  ];

  return (
    <Box>
      <HeadBar
        links={links}
        buttonText="dtektASite"
        buttonHref="/download"
        backgroundColor="blue.800"
      />
      <Box bg="linear-gradient(#001E33, #02518A);" minH="100vh" pt="150px" md="5%">
        <Box>
          <Text ml="5%" width="70%" color="white" fontFamily="Poppins, sans-serif" fontWeight="bold" fontSize="4xl">{getText("aboutObjectiveTitle")}</Text>
          <Paragraph marginLeft="5%" fontSize="2xl" color="white" width="50%" text="aboutObjectiveText"/>
        </Box>
        <Box mt="5%" justifyContent="right">
          <Text ml="5%" width="70%" color="white" fontFamily="Poppins, sans-serif" fontWeight="bold" fontSize="4xl" text>{getText("aboutHowItWorksTitle")}</Text>
          <Paragraph marginLeft="5%" fontSize="2xl" color="white" width="50%" text="aboutHowItWorksText"/>
        </Box>
        <Box mt="5%" alignSelf="left">
          <Text ml="5%" width="70%" color="white" fontFamily="Poppins, sans-serif" fontWeight="bold" fontSize="4xl">{getText("aboutSecurityTitle")}</Text>
          <Paragraph marginLeft="5%" fontSize="2xl" color="white" width="50%" text="aboutSecurityText"/>
        </Box>
        <Box mt="10%">
          <Footer/>
        </Box>
      </Box>
    </Box>
  )
}
